(function () {
  const section = document.currentScript.parentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initHeadingAnimation = (sectionEl) => {
    if (!sectionEl || !sectionEl.classList.contains('image-with-text-section')) return;
    const enableAnimation = sectionEl.querySelector('[data-enable-header-animation]');
    if (!enableAnimation) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      sectionEl.classList.add('anim-active');
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('anim-active');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -25% 0px' });
    observer.observe(sectionEl);
  };

  const initParallax = (sectionEl) => {
    if (!sectionEl) return;
    const parallaxItem = sectionEl.querySelector('.js-parallax');
    if (!parallaxItem || parallaxItem.dataset.parallaxReady === 'true') return;
    parallaxItem.dataset.parallaxReady = 'true';

    const resetPosition = () => {
      parallaxItem.style.transform = 'none';
    };
    if (reduceMotion.matches) {
      resetPosition();
      return;
    }
    if (!('IntersectionObserver' in window)) {
      resetPosition();
      return;
    }

    const basePropertyValue = parseInt(parallaxItem.dataset.parallaxPropertyValue, 10) || 0;
    const parallaxSteps = parallaxItem.dataset.parallaxSteps;
    let stepStart;
    let stepEnd;
    if (parallaxSteps) [stepStart, stepEnd] = parallaxSteps.split(',').map(Number);

    let isVisible = false;
    let ticking = false;
    let resizeTimer;

    const scrollAnimate = () => {
      if (!isVisible || reduceMotion.matches) return;
      const propertyValue = window.matchMedia('(max-width: 749px)').matches
        ? basePropertyValue * .6
        : basePropertyValue;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const rect = parallaxItem.getBoundingClientRect();
      const elementTop = rect.top + scrollY;
      const elementHeight = rect.height;
      const elementStart = elementTop - windowHeight;
      const elementEnd = elementTop + elementHeight;
      const scrollPosition = Math.max(0, scrollY - elementStart);
      const maxScroll = elementEnd - elementStart;
      let scrollPercent = (scrollPosition / maxScroll) * 100;
      scrollPercent = Math.max(0, Math.min(100, scrollPercent));
      let calculatedValue = 0;

      if (parallaxSteps) {
        if (scrollPercent >= stepStart && scrollPercent <= stepEnd) {
          const stepRange = stepEnd - stepStart;
          const stepProgress = (scrollPercent - stepStart) / stepRange;
          calculatedValue = propertyValue * stepProgress;
        } else if (scrollPercent > stepEnd) {
          calculatedValue = propertyValue;
        }
      } else {
        calculatedValue = (propertyValue * scrollPercent) / 100;
      }
      parallaxItem.style.transform = `translate3d(0, ${calculatedValue}px, 0)`;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        scrollAnimate();
        ticking = false;
      });
    };

    const visibilityObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        isVisible = entry.isIntersecting;
        if (isVisible) scrollAnimate();
      });
    }, { rootMargin: '100px 0px' });

    visibilityObserver.observe(parallaxItem);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(scrollAnimate, 100);
    });
    reduceMotion.addEventListener?.('change', (event) => {
      if (event.matches) resetPosition();
      else scrollAnimate();
    });
  };

  initHeadingAnimation(section);
  initParallax(section);
  document.addEventListener('shopify:section:load', (event) => {
    initHeadingAnimation(event.target);
    initParallax(event.target);
  });
})();
